import { HeadsetManufacturerType } from 'src/app/services/headset/headset-manufacturer-type';

export class ResetDraftSettings {
   public static readonly type = '[LocalStorage-Settings] Reset Draft Settings';

   constructor() {}
}

export class PrepareLocalStorageSettingsForModification {
   public static readonly type = '[LocalStorage-Settings] Prepare For Modification';

   constructor() {}
}

export class SaveLocalStorageSettings {
   public static readonly type = '[LocalStorage-Settings] Save Changes';

   constructor() {}
}

export class RejectChangedLocalStorageSettings {
   public static readonly type = '[LocalStorage-Settings] Discard Changes';

   constructor() {}
}

export class ChangeRingerDeviceId {
   public static readonly type = '[LocalStorage-Settings] Change Ringer DeviceId';

   constructor(public deviceId: string) {}
}

export class ChangeAudioInputDeviceId {
   public static readonly type = '[LocalStorage-Settings] Change Audio Input DeviceId';

   constructor(public deviceId: string) {}
}

export class ChangeHeadsetManufacturer {
   public static readonly type = '[LocalStorage-Settings] Change Headset Manufacturer';

   constructor(public manufacturer: HeadsetManufacturerType) {}
}

export class ChangeAudioOutputDeviceId {
   public static readonly type = '[LocalStorage-Settings] Change Audio Output DeviceId';

   constructor(public deviceId: string) {}
}
